import { useMemo } from "react";
import type { CSSProperties } from "react";
import type { Conversation } from "@/api/models/api-types";
import { moduleRegistry, useActiveModule, type ModuleId } from "@/modules";

/**
 * Sohbetin ait olduğu modül (sunucudaki `module` alanı) ve sidebar öğesinin
 * o modülün rengine boyanması için scope stili.
 * Modül içindeyken liste zaten filtreli olduğu için işaret gösterilmez.
 */
export const useConversationModule = (conversation: Conversation) => {
  const activeModule = useActiveModule();
  const moduleId = conversation.module;

  const module = useMemo(
    // Backend serbest string döner; registry'de yoksa undefined → işaretsiz
    () => (moduleId ? moduleRegistry.getModuleById(moduleId as ModuleId) : undefined),
    [moduleId],
  );

  const scopeStyle = useMemo<CSSProperties | undefined>(
    () => (module ? ({ "--module-hue": module.theme.hue } as CSSProperties) : undefined),
    [module],
  );

  return {
    module,
    /** Hub'da (aktif modül yokken) küçük modül ikonu gösterilir. */
    showBadge: !!module && !activeModule,
    scopeStyle,
  };
};
